<app-loading *ngIf="contentReady"></app-loading>
@if(!noData && tokenExists){
<div class="orders-vcash-page" style="margin-bottom: 70px;">

  <!-- TOP AREA -->
  <section class="orders-top">
    <div class="orders-appbar">
      <button class="orders-appbar-btn" type="button" (click)="goBack()">
        <img [src]="isAr ? '/assets/e-commerce/icons/60.webp' : '/assets/e-commerce/icons/61.webp'" alt="back" />
      </button>

      <h1 class="orders-appbar-title"> {{ "myorders" | transloco }}</h1>

      <div class="orders-appbar-count">
        {{ allData?.length || 0 }}
      </div>
    </div>
  </section>

  <!-- CONTENT -->
  <div class="orders-content">

    <!-- OVERVIEW CARD -->
    <section class="orders-overview-card">
      <div class="orders-overview-top">
        <div class="orders-overview-main">
          <span class="orders-overline">{{ "myorders" | transloco }}</span>
          <h2>{{ allData?.length || 0 }}</h2>
          <p>{{ "Track, reorder and manage your orders easily" | transloco }}</p>
        </div>

        <div class="orders-overview-side">
          <span>{{ "order count" | transloco }}</span>
          <strong>{{ allData?.length || 0 }}</strong>
        </div>
      </div>

    </section>

    <!-- ORDERS LIST -->
    <section class="orders-list-section">
      <div class="orders-section-header">
        <h3>{{ "recent orders" | transloco }}</h3>
      </div>

      <div class="orders-list">
        <div class="order-modern-card" *ngFor="let order of allData">

          <div class="order-modern-top">
            <!-- STATUS IMAGE -->
            <div class="order-status-media">
              <ng-container [ngSwitch]="order.order_status">
                <img src="/assets/e-commerce/icons/67.webp" *ngSwitchCase="1" alt="product" class="order-status-img">
                <img src="/assets/e-commerce/icons/68.webp" *ngSwitchCase="2" alt="product" class="order-status-img">
                <img src="/assets/e-commerce/icons/69.webp" *ngSwitchCase="3" alt="product" class="order-status-img">
                <img src="/assets/e-commerce/icons/70.webp" *ngSwitchCase="4" alt="product" class="order-status-img">
                <img src="/assets/e-commerce/icons/71.webp" *ngSwitchDefault alt="product" class="order-status-img">
              </ng-container>
            </div>

            <!-- MAIN INFO -->
            <div class="order-modern-main">

              <div class="order-modern-row">
                <ng-container [ngSwitch]="order.order_status">
                  <span class="status-label status-label--pending" *ngSwitchCase="1">
                    {{ "pending" | transloco }}
                  </span>

                  <span class="status-label status-label--approved" *ngSwitchCase="2">
                    {{ "approved" | transloco }}
                  </span>

                  <span class="status-label status-label--rejected" *ngSwitchCase="3">
                    {{ "rejected" | transloco }}
                  </span>

                  <span class="status-label status-label--ontheway" *ngSwitchCase="4">
                    {{ "on the way" | transloco }}
                  </span>

                  <span class="status-label status-label--shipped" *ngSwitchDefault>
                    {{ "shipped" | transloco }}
                  </span>
                </ng-container>

                <div class="order-total-pill">
                  {{ order.total }} {{ "egpe" | transloco }}
                </div>
              </div>

              <div class="order-meta-line">
                {{ convertDate(order.created_at) }}
              </div>

              <div class="order-number-line">
                {{ "order number" | transloco }}
                <strong>#{{ order.id }}</strong>
              </div>

              @if(order.delivery_hero != null && order.order_status != "5" && order.order_status != "3"){
              <div class="order-hero-box">
                <span class="order-hero-label">
                  {{ "your order delivery hero" | transloco }}
                </span>

                <div class="order-hero-number">{{ order.delivery_hero }}</div>

                <div class="order-hero-actions">
                  <button class="order-chip order-chip--call" (click)="callHero(order.delivery_hero)">
                    {{ "call hero" | transloco }}
                  </button>

                  <button class="order-chip order-chip--call" (click)="chatWithHero(order.delivery_hero)">
                    {{ "chat with hero" | transloco }}
                  </button>
                </div>
              </div>
              }

            </div>
          </div>

          <!-- ACTIONS -->
          <div class="order-action-grid">
            @if(order.order_status == "5" || order.order_status == "3"){
            <button class="order-chip order-chip--dark" (click)="reorder(order.product_id,order.quantity)">
              {{ "reorder" | transloco }}
            </button>
            }

            <button class="order-chip order-chip--outline" (click)="details(order)">
              {{ "order details" | transloco }}
            </button>

            @if(order.order_status != "3" && order.order_status == "5"){
            <button *ngIf="canRefund(order.created_at)" class="order-chip order-chip--pending">
              {{ "refund" | transloco }}
            </button>
            }

            <button class="order-chip order-chip--approved" (click)="invoice(order)">
              {{ "details" | transloco }}
            </button>

            @if(order.order_status != "5" && order.order_status != "4"){
            <button *ngIf='order.order_status != "3"' (click)="orderStatuschange(order.id,3)"
              class="order-chip order-chip--rejected">
              {{ "Cancel" | transloco }}
            </button>
            }
          </div>

        </div>
      </div>
    </section>
  </div>
</div>
}
@else{
<app-emptyorders></app-emptyorders>
}